import React, { memo, useRef, useState } from 'react';
import { Box } from '@mantine/core';

import CanvasTable from '../../../../../components/CanvasTable';
import * as Styled from '../../../../../components/CanvasTable/style';
import ErrorBoundary from '../../../../../components/ErrorBoundary';

export const Table = memo(
  ({
    key,
    className,
    getCellStyle,
    data,
    foundCell,
    rowPinning,
    columnPinning,
    zoomLevel,
    headerIndex = 1,
    footerIndex,
    onFocusedCell,
    handleSelection,
    columns,
    columnsTypes,

    isActiveFullScreen,
    style,
    isStructured,
    width
  }) => {
    const [selectedCells, setSelectedCells] = useState([]);

    const scrolledPosition = useRef({
      top: 0,
      left: 0
    });

    const onChangeScrollPosition = e => {
      scrolledPosition.current = {
        top: e?.top ?? 0,
        left: e?.left ?? 0
      };
    };

    if (!columns) return <></>;

    return (
      <ErrorBoundary componentName="canvas-table">
        <Box id="grid-table-canvas-wrapper" h="calc(100% - 46px)">
          <Styled.CanvasDataGridContextMenu id="grid-table-canvas-context-menu" />
          <CanvasTable
            data={data}
            foundCell={foundCell}
            zoomLevel={zoomLevel}
            startLine={headerIndex}
            endLine={footerIndex}
            getCellStyle={getCellStyle}
            handleSelection={handleSelection}
            setSelectedCells={setSelectedCells}
            onFocusedCell={onFocusedCell}
            isActiveFullScreen={isActiveFullScreen}
            style={style}
            rowPinning={rowPinning}
            columnPinning={columnPinning}
            isStructured={isStructured}
            key={key}
            scrolledPosition={scrolledPosition.current}
            onChangeScrollPosition={onChangeScrollPosition}
            className={className}
            width={width}
            columnsTypes={columnsTypes}
            hideHoverCopyOnFirstRow
          />
        </Box>
      </ErrorBoundary>
    );
  }
);

Table.displayName = 'Table';
